import {Component, inject, OnInit} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import dayjs from 'dayjs/esm';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import locale from '@angular/common/locales/en';
// jhipster-needle-angular-add-module-import JHipster will add new module here
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import { ApplicationConfigService } from 'app/core/config/application-config.service';
import { fontAwesomeIcons } from './config/font-awesome-icons';
import MainComponent from './layouts/main/main.component';
import {DigitalTicketComponent} from "./digital-ticket/digital-ticket.component";
import {mergeMap} from "rxjs/operators";
import {HttpResponse} from "@angular/common/http";
import {ITicket} from "./entities/ticket/ticket.model";
import {EMPTY, of} from "rxjs";
import {TicketService} from "./entities/ticket/service/ticket.service";

@Component({
  standalone: true,
  selector: 'jhi-app',
  templateUrl: './app.component.html',
  imports: [
    MainComponent,
    DigitalTicketComponent,
  ],
})
export default class AppComponent {
  private applicationConfigService = inject(ApplicationConfigService);
  private iconLibrary = inject(FaIconLibrary);
  private dpConfig = inject(NgbDatepickerConfig);
  // private ticketService = inject(TicketService);
  currentPath: string = '';
  // private router = inject(Router);

  // isPublicPage = false;
  // ticket: ITicket | undefined = undefined;

  constructor() {
    this.applicationConfigService.setEndpointPrefix(SERVER_API_URL);
    registerLocaleData(locale);
    this.iconLibrary.addIcons(...fontAwesomeIcons);
    this.dpConfig.minDate = { year: dayjs().subtract(100, 'year').year(), month: 1, day: 1 };

    // this.router.events.subscribe(() => {
    //   console.log('router event', this.router.url);
    //   this.isPublicPage = this.router.url.startsWith('/digital-ticket');
    //
    //   var ticketId = this.router.url.split("/")[2];
    //   if(ticketId) {
    //     this.ticketService.find(Number(ticketId))
    //       .pipe(
    //         mergeMap((ticket: HttpResponse<ITicket>) => {
    //           if (ticket.body) {
    //             return of(ticket.body);
    //           }
    //           return EMPTY;
    //         }),
    //       ).subscribe((ticket: ITicket) => {
    //       this.ticket = ticket;
    //     });
    //   }
    // });
  }
}
